const key = "checkout-context";
import { injectLocal, provideLocal } from "@vueuse/core";
import type { FormContext } from "vee-validate";
import { ref } from "vue";

export const provideCheckoutContext = () => {
  const guestConditionOverwrites = ref(new Map<string, unknown>());

  const form = ref<FormContext>();
  const state = { guestConditionOverwrites, form };

  provideLocal(key, state);

  return state;
};

export const injectCheckoutContext = () => {
  return injectLocal(key) as ReturnType<typeof provideCheckoutContext>;
};
